import React, {Component} from "react";
import Style from "./FJToolbarCrop.module.less";
import InlineSVG from "react-inlinesvg";
import FJToolbarButton from "./FJToolbarButton";
import FJToolbarIconButton from "./FJToolbarIconButton";
import maskSquareIcon from "../../../icon/mask1.svg";
import maskCircleIcon from "../../../icon/mask2.svg";
import cancelIcon from "../../../icon/cancel.svg";
import okIcon from "../../../icon/ok.svg";
import FJLocalStore from "../../../store/FJLocalStore";

class FJToolbarCrop extends Component {

  _handleClick = (e) => {
    e.stopPropagation();
  }

  render() {
    let {handleCropSquare, handleCropCircle, handleResetCrop, handleCancelCrop, handleSureCrop} = this.props;
    return (
      <div onMouseDown={this._handleClick} className={Style.crop_container}>
        <div className={Style.crop_left}>
          <FJToolbarIconButton icon={<InlineSVG src={maskSquareIcon}/>}
                               className={Style.icon_btn}
                               onClick={handleCropSquare}/>
          <FJToolbarIconButton icon={<InlineSVG src={maskCircleIcon}/>}
                               className={Style.icon_btn}
                               onClick={handleCropCircle}/>
        </div>
        <div className={Style.crop_right}>
          <div className={Style.reset_btn}
               onClick={handleResetCrop}>
            {FJLocalStore._('reset')}
          </div>
          <FJToolbarButton icon={cancelIcon}
                           style={{marginLeft: '6px'}}
                           text={FJLocalStore._('cancel')}
                           onClick={handleCancelCrop}/>
          <FJToolbarButton icon={okIcon}
                           style={{marginLeft: '6px'}}
                           text={FJLocalStore._('OK')}
                           onClick={handleSureCrop}/>
        </div>
      </div>
    )
  }
}

export default FJToolbarCrop;
